"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInView = useInView;
var _react = require("react");
function useInView(ref, callback) {
  var hasIntersectionObserverSupport = 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in IntersectionObserverEntry.prototype;
  var observer = (0, _react.useRef)(null);
  var handleObserver = (0, _react.useCallback)(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        if (observer.current && ref.current) {
          observer.current.unobserve(ref.current);
          callback();
        }
      }
    });
  }, [callback, ref]);
  var observe = (0, _react.useCallback)(function () {
    if (hasIntersectionObserverSupport) {
      observer.current = new IntersectionObserver(handleObserver);
      if (ref.current) {
        observer.current.observe(ref.current);
      }
    } else {
      callback();
    }
  }, [callback, handleObserver, hasIntersectionObserverSupport, ref]);
  (0, _react.useEffect)(function () {
    observe();
  }, [observe]);
}